// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"45bba1e1","558":"61eddf37","787":"8416ac43","895":"6cab63a8"}[chunkId] + ".chunk.js";
};